// import PropTypes from '../_util/vue-types';
import { computed, provide } from 'vue';
import { propTypes } from '../vc-progress/src/types';
export var injectExtraPropsKey = Symbol();
var FunctionProvider = {
  inheritAttrs: false,
  props: {
    extraProps: propTypes.object
  },
  setup: function setup(props, _ref) {
    var slots = _ref.slots;
    provide(injectExtraPropsKey, computed(function () {
      return props.extraProps;
    }));
    return function () {
      var _a;

      return (_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots);
    };
  }
};
export default FunctionProvider;